export enum EntityField {
  StatusChangeReason = 'StatusChangeReason',
  StatusChangeDescription = 'StatusChangeDescription',
  BeneficiaryVerificationStateId = 'BeneficiaryVerificationStateId',
  BeneficiaryDateOfDeath = 'BeneficiaryDateOfDeath',
  FirstName = 'FirstName',
  LastName = 'LastName',
  ContactPreferenceId = 'ContactPreferenceId',
  Email = 'Email',
  Landline = 'Landline',
  MobileNumber = 'MobileNumber',
  Fax = 'Fax',
  PolicyPaidToDate = 'PolicyPaidToDate',
  PolicyNumber = 'PolicyNumber',
  IsContingent = 'IsContingent',
  ContactPhone = 'ContactPhone',
  OTPChannelId = 'OTPChannelId',
  NotificationChannelId = 'NotificationChannelId',
  MilestoneId = 'MilestoneId',
}
